import { FC, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { Container } from '@/components';

import { BillingCycleSwitcher } from './components/BillingCycleSwitcher';
import { PlanCard } from './components/PlanCard';

import styles from './styles.module.scss';
import { PricingPageContext } from '../../contexts';

export const PlansOverview: FC = () => {
  const { t } = useTranslation('pricingV2');
  const { productsMetadata } = useContext(PricingPageContext);

  return (
    <Box component="section" className={styles.section}>
      <Container className={styles.container}>
        <Typography variant="h1" className={styles.title}>
          {t('title')}
        </Typography>
        <Box className={styles.switcher}>
          <BillingCycleSwitcher />
        </Box>
        <Box className={styles.cards}>
          {productsMetadata.map((metadata) => (
            <PlanCard key={metadata.family} metadata={metadata} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};
